import { ApiMethod, constructFetchFn } from "@utils/api";
import { API } from "@utils/constants";

export const setting = (programId) =>
  constructFetchFn({
    method: ApiMethod.POST,
    url: API.SETTING,
    body: {
      programId,
    },
  });

export const getAdminSetting = () =>
  constructFetchFn({
    method: ApiMethod.POST,
    url: API.ADMIN_SETTING,
  });
